import React, { useEffect, useState } from "react";
import { ArrowPathIcon } from "@heroicons/react/24/outline";
// import ReusableSearchInput from "../../../components/ReusableSearchInput";
import MonthDatePicker from "../../../components/MonthDatePicker";
import moment from "moment";
import { useReportTimesheetContext } from "../../../context/ReportTimsheetContex";
import ReactDataTable from "../../../components/ReactDataTable";
import { GetutilisationResponse } from "../../../model/timesheet";
import { formatAsSevenDigitNumber } from "../../../helper/convertionHealper";
// import { ExcelFileType, exportToExcel } from "../../../helper/exportToExcel";

const FinanceMonthlyReportPage: React.FC = () => {
  const { utilisationReportList, getUtilisationReportList, setUtilisationReportList } =
    useReportTimesheetContext();
  const [errorMessage, setErrorMessage] = useState<string>("");
  // const [userName, setUserName] = useState<string>("");
  // const [userID, setUserID] = useState<number | null>(null);
  const [startDate, setStartDate] = useState<Date | null>(null);

  const [reportDate, setReportDate] = useState<{ start_date: string; end_date: string }>();

  const excelSheetHeader: string[] = [
    "Client Name",
    "Project Code",
    "Project Name",
    "Department",
    "Employee ID",
    "Employee Name",
    "Billing",
    "Location",
    "Timesheet Approver",
    "Start Date",
    "End Date",
    "Comments",
    "Current Employee Status",
    "Total Project Activity [hrs]",
    "Total Non-Project Activity [hrs]",
    "Project Utilization(%)",
    "Total Percantage Utilization(%)",
  ];

  const columns = [
    {
      name: "Client Name",
      selector: (row: GetutilisationResponse) => row.ClientName,
      sortable: true,
    },
    {
      name: "Project Code",
      selector: (row: GetutilisationResponse) => row.project_code,
      sortable: true,
    },
    {
      name: "Project Name",
      selector: (row: GetutilisationResponse) => row.project_name,
      sortable: true,
    },
    {
      name: "Department",
      selector: (row: GetutilisationResponse) => row.department,
      sortable: true,
    },
    {
      name: "Employee ID",
      selector: (row: GetutilisationResponse) =>
        row.employee_id ? formatAsSevenDigitNumber(row.employee_id) : "",
      sortable: true,
    },
    {
      name: "Employee Name",
      selector: (row: GetutilisationResponse) => row.employee,
      sortable: true,
    },
    {
      name: "Billing",
      selector: (row: GetutilisationResponse) => row.is_billable,
      sortable: true,
    },
    {
      name: "Location",
      selector: (row: GetutilisationResponse) => row.location,
      sortable: true,
    },
    {
      name: "TimeSheet Approver",
      selector: (row: GetutilisationResponse) => row.approver,
      sortable: true,
    },
    {
      name: "Start Date",
      selector: (row: GetutilisationResponse) => row.start_ts,
      sortable: true,
    },
    {
      name: "End Date",
      selector: (row: GetutilisationResponse) => row.end_ts,
      sortable: true,
    },
    {
      name: "Comments",
      selector: (row: GetutilisationResponse) => row.description,
      sortable: true,
    },
    {
      name: "Current Employee Status",
      selector: (row: GetutilisationResponse) => row.CurrentStatus,
      sortable: true,
    },
    {
      name: "Total Project Activity [hrs]",
      selector: (row: GetutilisationResponse) => row.total_project_activity,
      sortable: true,
    },
    {
      name: "Total Non-project Activity [hrs]",
      selector: (row: GetutilisationResponse) => row.total_nonproject_activity,
      sortable: true,
    },
    {
      name: "Project Utilization(%)",
      selector: (row: GetutilisationResponse) => row.project_utilization,
      sortable: true,
    },
    {
      name: "Total Percantage Utilization(%)",
      selector: (row: GetutilisationResponse) => row.total_percantage_utilization,
      sortable: true,
    },
  ];

  useEffect(() => {
    if (startDate) {
      const fetchTimesheetData = async () => {
        setErrorMessage("");
        // if (userID === null) {
        //   setErrorMessage("Please Select Employee Name");
        //   return;
        // }

        if (!startDate) {
          setErrorMessage("Please Select Month");
          return;
        }
        const startOfMonth = moment(startDate).startOf("month");
        const endOfMonth = moment(startDate).endOf("month");
        setReportDate({
          start_date: moment(startOfMonth).format("DD-MM-YYYY"),
          end_date: moment(endOfMonth).format("DD-MM-YYYY"),
        });
        await getUtilisationReportList({
          start_date: moment(startOfMonth).format("DD-MM-YYYY"),
          end_date: moment(endOfMonth).format("DD-MM-YYYY"),
        });
        // exportToExcel({
        //     [],
        //     excelSheetHeader,
        //     fileName: `MonthlyBillingReports-${moment(startOfMonth).format("DD MMM YYYY")} to ${moment(endOfMonth).format("DD MMM YYYY")}`,
        //     fileType: 'xlsx' as ExcelFileType,
        //   })

        // const weeks = generateWeeksInMonth(startDate, userID);
        // console.log("Generated weeks:", weeks);

        // setTimesheetData(weeks);
      };
      fetchTimesheetData();
    }
  }, [startDate]);

  const refreshTable = () => {
    // setUserName("");
    // setUserID(null);
    setUtilisationReportList(null);
    setStartDate(null);
    setErrorMessage("");
  };

  const reportListData: GetutilisationResponse[] | undefined = React.useMemo(() => {
    return utilisationReportList?.map((item) => ({
      ClientName: item.ClientName,
      project_code: item.project_code,
      project_name: item.project_name,
      department: item.department,
      employee_id: item.employee_id && formatAsSevenDigitNumber(item.employee_id),
      employee: item.employee,
      is_billable: item.is_billable,
      location: item.location,
      approver: item.approver,
      start_ts: item.start_ts,
      end_ts: item.end_ts,
      description: item.description,
      CurrentStatus: item.CurrentStatus,
      total_project_activity:item.total_project_activity,
      total_nonproject_activity: item.total_nonproject_activity,
      project_utilization: item.project_utilization + '%',
      total_percantage_utilization: item.total_percantage_utilization + '%'
    }));
  }, [utilisationReportList]);
  console.log("utilisationReportList", utilisationReportList);
  // Wrap the setViewTimesheet function in useCallback to prevent unnecessary re-renders

  return (
    <div>
      <div className='max-w-7xl gap-x-6 gap-y-4 grid gap-3 grid-cols-1 sm:grid-cols-2 md:grid-cols-3 '>
        {/* <div>
          <label
            htmlFor='employeeName'
            className='block text-sm font-medium leading-6 text-gray-900 dark:text-gray-400'
          >
            Employee Name
          </label>
          <div className='mt-2'>
            <ReusableSearchInput
              value={userName}
              onChange={(e) => setUserName(e.target.value)}
              setOptionsData={(item) => {
                setUserID(item?.id ?? null);
                setUserName(item?.ldap_uid ?? "");
              }}
            />
          </div>
        </div> */}
        <div>
          <label
            htmlFor='month'
            className='block text-sm font-medium leading-6 text-gray-900 dark:text-gray-400'
          >
            Month
          </label>
          <div className='mt-2'>
            <MonthDatePicker
              onChange={setStartDate}
              selectedDate={startDate}
              isClearable={true}
              maxDate={new Date()}
              dateFormat='MM/yyyy'
            />
          </div>
        </div>

        <div className='flex space-x-4'>
          {/* {myReportList && myReportList.length > 0 && ( */}
          {/* <ExportDropdown
              data={exportReport ?? []}
              excelheader={excelSheetHeader as string[]}
              start={startDate}
              end={endDate}
            /> */}
          {/* )} */}
          <button
            onClick={refreshTable}
            className='flex items-center px-4 py-2 lg:mt-9 text-sm bg-red-700 hover:bg-red-800 text-white rounded-lg focus:outline-none'
          >
            <ArrowPathIcon className='h-5 w-5 text-white mr-2' /> Reset
          </button>
        </div>
      </div>
      <div className='max-w-7xl gap-x-6 gap-y-4 grid gap-3 grid-cols-1 sm:grid-cols-3 md:grid-cols-4 my-4'>
        {errorMessage && <p className='my-2 text-sm text-red-600'>{errorMessage}</p>}
      </div>
      <ReactDataTable
        columns={columns}
        data={reportListData ?? []}
        showFilter={reportListData ? true : false}
        showExport={true}
        actionOption={false}
        ReportName={`MonthlyBillingreport-(${reportDate?.start_date} to ${reportDate?.end_date})`}
        searchLabelName='Search by Employee ID, Employee Name, etc'
        excelSheetHeader={excelSheetHeader}
      />
    </div>
  );
};

export default FinanceMonthlyReportPage;
